import styled from 'styled-components';

export default styled.div`
  grid-area: status;
  align-self: center;
`;
